"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getParamValue = exports.isExternalLink = exports.isSafeLink = exports.isTelLink = exports.isMailtoLink = exports.isLocalLink = void 0;

var _urlParse = _interopRequireDefault(require("url-parse"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var protocolRegexp = /^https?/;
var localHrefRegexp = /^#/;
var mailtoHrefRegexp = /^mailto:(.+)/;
var telHrefRegexp = /^tel:\+?(\d+)/;

var isLocalLink = function isLocalLink(url) {
  if (localHrefRegexp.test(url)) {
    return true;
  }

  return false;
};

exports.isLocalLink = isLocalLink;

var isMailtoLink = function isMailtoLink(url) {
  if (mailtoHrefRegexp.test(url)) {
    return true;
  }

  return false;
};

exports.isMailtoLink = isMailtoLink;

var isTelLink = function isTelLink(url) {
  if (telHrefRegexp.test(url)) {
    return true;
  }

  return false;
};

exports.isTelLink = isTelLink;

var isSafeLink = function isSafeLink(url, safeDomains) {
  var hostname = (0, _urlParse["default"])(url).hostname;

  if (!hostname || !safeDomains) {
    return false;
  }

  return safeDomains.some(function (domain) {
    return domain === hostname;
  });
};

exports.isSafeLink = isSafeLink;

var isExternalLink = function isExternalLink(url) {
  if (protocolRegexp.test(url)) {
    return true;
  }

  return false;
};

exports.isExternalLink = isExternalLink;

var getParamValue = function getParamValue(url, key) {
  var pathParts = url.split('/');
  var keyIndex = pathParts.findIndex(function (pathPart) {
    return pathPart === key;
  });

  if (keyIndex < 0) {
    return null;
  }

  var value = pathParts[keyIndex + 1];
  return value ? value : null;
};

exports.getParamValue = getParamValue;